import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { BackendApiService } from '../services/backend-api.service';
import { BaseUrlConstantsService } from '../services/base-url-constants.service';
import { FormsModule } from '@angular/forms';
import { DeviceMacUsageListComponent } from "../device-mac-usage-list/device-mac-usage-list.component";
@Component({
  selector: 'app-device-mac-modal',
  standalone: true,
  imports: [MatIconModule, CommonModule, NgxChartsModule, FormsModule, DeviceMacUsageListComponent],
  templateUrl: './device-mac-modal.component.html',
  styleUrl: './device-mac-modal.component.scss'
})
export class DeviceMacModalComponent {
  @Input() deviceMacArray: any;
  @Input() macs: any[];
  @Input() filterType: string;
  @Input() startDate: string;
  @Input() endDate: string;

  @Output() closeModal = new EventEmitter<void>();
  public macArray: any;
  public thisMonth: boolean = true;
  public prevMonth: boolean = false;
  public isListModalOpen: boolean = false;
  public macAddressClicked: string = "";
  public isLoading: boolean = true;

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    console.log("asdadasdasd")
    console.log(this.deviceMacArray)
    this.fetchMacCardsData();
  }

  constructor(private service: BackendApiService) { }

  async fetchMacCardsData() {
    console.log(this.deviceMacArray)
    const userId = this.deviceMacArray.userId;
    console.log(userId)
    try {
      const result: any = await this.service.getDataV2(BaseUrlConstantsService.GET_MAC_CARD_DATA + `/${userId}?filterType=${this.filterType}&startDate=${this.startDate}&endDate=${this.endDate}`);
      if (result.success === true) {
        this.macArray = result.data;
        if (Array.isArray(this.macArray.macs)) {
          this.macArray.macs.forEach(mac => {
            mac.isListVisible = false;
          });
        }
        this.isLoading = false;
      }
      console.log(result)
    }
    catch (error) {
      console.log(error);
    }
    finally {
      this.isLoading = false;
    }
  }

  onClose(): void {
    this.closeModal.emit();
  }

  secondsToDDHHMMSS(totalSeconds: number) {
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const pad = (num: number) => String(num).padStart(2, '0');

    return `${pad(days)}:${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  }

  get pieChartData() {
    if (!this.deviceMacArray) return [];
    const excellentPercent = this.macArray?.macs.length > 0 ? (this.macArray.devicesAbove95 / this.macArray.macs.length) * 100 : 0;
    const goodPercent = this.macArray?.macs.length > 0 ? (this.macArray.devicesBetween90And95 / this.macArray.macs.length) * 100 : 0;
    const attentionPercent = this.macArray?.macs.length > 0 ? (this.macArray.devicesBelow90 / this.macArray.macs.length) * 100 : 0;
    return [
      {
        "name": "Excellent",
        "value": excellentPercent
      },
      {
        "name": "Good",
        "value": goodPercent
      },
      {
        "name": "Attention",
        "value": attentionPercent
      }
    ];
  }
  customColorObjects = [
    { name: 'Excellent', value: '#39FF14' },
    { name: 'Good', value: '#FFFF00' },
    { name: 'Attention', value: '#FF3131' }
  ];
  get chartColors(): string[] {
    return this.customColorObjects.map(c => c.value);
  }

  // handleMacCardClick(item: any) {
  //   console.log(item)
  //   this.isListModalOpen = !this.isListModalOpen;
  //   console.log(this.isListModalOpen)
  // }

  onDateChange() {
    this.thisMonth = false;
    this.prevMonth = false;
    this.filterType = 'range';
    this.applyFilters();

  }

  onThisMonthChange() {
    if (this.thisMonth) {
      this.prevMonth = false;
      const today = new Date();
      const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      const endOfToday = today;

      this.startDate = this.formatDate(startOfMonth);
      this.endDate = this.formatDate(endOfToday);
      this.filterType = "currentMonth";

      this.applyFilters();
    }
  }

  onPrevMonthChange() {
    if (this.prevMonth) {
      this.thisMonth = false;
      const today = new Date();
      const startOfPrevMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      const endOfPrevMonth = new Date(today.getFullYear(), today.getMonth(), 0); // day 0 of current month = last of previous

      this.startDate = this.formatDate(startOfPrevMonth);
      this.endDate = this.formatDate(endOfPrevMonth);
      this.filterType = "previousMonth";

      this.applyFilters();
    }
  }

  initializeDateFilters() {
    const today = new Date();
    const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const endOfToday = today;

    this.startDate = this.formatDate(startOfMonth);
    this.endDate = this.formatDate(endOfToday);
    this.thisMonth = true;
    this.prevMonth = false;
    this.filterType = "currentMonth";

    this.applyFilters();
  }
  private formatDate(date: Date): string {
    return date.toISOString().split('T')[0];
  }

  private applyFilters() {
    this.fetchMacCardsData();
  }
  toggleDetails(clickedItem: any) {
    console.log(clickedItem)
    this.macArray.macs.forEach((item: any) => {
      item.isListVisible = (item === clickedItem) ? !item.isListVisible : false;
    });
    console.log(this.macArray.macs)
    this.macAddressClicked = clickedItem.mac_address;
    this.isListModalOpen = !this.isListModalOpen;
  }

  closeListModal() {
    console.log("close modal")
    this.isListModalOpen = false;
  }
}
